import type { TStoreName } from "../types/store";

export const APP_NAME = import.meta.env.VITE_REACT_APP_NAME as TStoreName;

export const STORE_SUFFIX = (APP_NAME.charAt(0).toUpperCase() + APP_NAME.slice(1)) as Capitalize<TStoreName>;
